module.exports = __webpack_public_path__ + "media/content-creator/mobile-travel-2-b1549590.png";